/**
 * @generated SignedSource<<3710b46165cecf0020ed6375d62c2cc7>>
 * @relayHash f37b4597cc91565be901f611ccfbdd1a
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID dccb68f3436f199d9cc56f74f8faf3dbbc32bc642a759b50d28f525e02184293

import type { ConcreteRequest } from 'relay-runtime';
export type useLabelsSelectPropsRecommendedLabelsQuery$variables = {
  contentId: string;
  spaceId: string;
};
export type useLabelsSelectPropsRecommendedLabelsQuery$data = {
  readonly getRecommendedLabels: {
    readonly recommendedLabels: ReadonlyArray<{
      readonly id: string;
      readonly name: string;
      readonly namespace: string;
      readonly strategy: ReadonlyArray<string>;
    } | null | undefined>;
  } | null | undefined;
};
export type useLabelsSelectPropsRecommendedLabelsQuery = {
  response: useLabelsSelectPropsRecommendedLabelsQuery$data;
  variables: useLabelsSelectPropsRecommendedLabelsQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "contentId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "spaceId"
  }
],
v1 = [
  {
    "args": [
      {
        "kind": "Variable",
        "name": "entityId",
        "variableName": "contentId"
      },
      {
        "kind": "Literal",
        "name": "entityType",
        "value": "page"
      },
      {
        "kind": "Variable",
        "name": "spaceId",
        "variableName": "spaceId"
      }
    ],
    "concreteType": "RecommendedLabels",
    "kind": "LinkedField",
    "name": "getRecommendedLabels",
    "plural": false,
    "selections": [
      {
        "concreteType": "RecommendedLabelItem",
        "kind": "LinkedField",
        "name": "recommendedLabels",
        "plural": true,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "id"
          },
          {
            "kind": "ScalarField",
            "name": "name"
          },
          {
            "kind": "ScalarField",
            "name": "namespace"
          },
          {
            "kind": "ScalarField",
            "name": "strategy"
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "useLabelsSelectPropsRecommendedLabelsQuery",
    "selections": (v1/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useLabelsSelectPropsRecommendedLabelsQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "f37b4597cc91565be901f611ccfbdd1a",
    "id": "dccb68f3436f199d9cc56f74f8faf3dbbc32bc642a759b50d28f525e02184293",
    "metadata": {},
    "name": "useLabelsSelectPropsRecommendedLabelsQuery",
    "operationKind": "query",
    "text": "query useLabelsSelectPropsRecommendedLabelsQuery($contentId:ID!,$spaceId:ID!){getRecommendedLabels(entityId:$contentId,entityType:\"page\",spaceId:$spaceId){recommendedLabels{id,name,namespace,strategy}}}"
  }
};
})();

(node as any).hash = "a2fc96b70df294c160410b79118346b9";

export default node;
